import { getJson, postJson, putJson, withDone, withValidate } from '@rad/utility/http';
export const getRoles = getJson(`/api/roles`);
export const getPermissions = getJson(`/api/roles/permissions`);
export const getRolePermissions = (roleName) => withDone(postJson('/api/roles/role-permissions', { name: roleName }))();
export const createRole = (form) => withDone(withValidate(postJson('/api/roles', form)))();
export const updateRolePermissions = (form) => withDone(withValidate(putJson('/api/roles/role-permissions', form)))();
